/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, Observable, Subject } from 'rxjs';
import { AppConfig } from '../app-config';

@Injectable()
export abstract class ConfigLoader {
  protected readonly http: HttpClient = inject(HttpClient);
  protected readonly config: AppConfig = inject(AppConfig);
  protected readonly translate: TranslateService = inject(TranslateService);

  protected loaderEmitter = new Subject<AppConfig>();

  public isLoadedValue = false;

  public load(origin?: string): Observable<AppConfig> {
    this.loadConfiguration(origin);
    return this.loaderEmitter.asObservable();
  }
  protected abstract loadConfiguration(origin?: string);

  protected getConfiguration(path: string) {
    const config$ = this.http.get<any>(`${path}?${new Date().getTime()}`);
    forkJoin([config$, this.loadVersion$()]).subscribe((data) => {
      const result = data[0];
      const version = data[1];
      result.appVersion = version.appVersion;
      result.appVersionDate = version.date;
      this.config.init(result);
      this.isLoadedValue = true;
      this.loaderEmitter.next(this.config);
      this.initTranslation();
    });
  }

  protected loadVersion$(): Observable<any> {
    return this.http.get<any>(`assets/version.json?${new Date().getTime()}`);
  }

  protected initTranslation() {
    if (!this.config.lang || this.config.lang.length === 0) {
      this.config.lang = ['fr', 'en'];
    }

    const userLang = navigator.language;
    const navigatorLanguage = this.config.lang.find(
      (lang) => userLang.indexOf(lang) === 0,
    );
    this.translate.use(navigatorLanguage ?? this.config.lang[0]);
  }
}
